var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventsHeroCropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.24 1.64 650.38 415.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.91,60.93,81,60.65l6.66-.11c2.23,0,4.47,0,6.7-.06h.44v.45l.06,11.19v.5h-.5l-13.24-.06c-4.41,0-8.83-.12-13.24-.17h-.28v-.27c0-1.9.08-3.79.13-5.66Zm0,0,.14,5.65c0,1.87.11,3.71.13,5.54l-.27-.27c4.41-.06,8.83-.16,13.24-.17l13.24-.06-.5.5,0-11.19.45.44c-2.18,0-4.36,0-6.55,0l-6.58-.11Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.68,46.82l13.13-.28,6.66-.11c2.22,0,4.46,0,6.69-.06h.44v.45l0,11.19v.5h-.5l-13.24-.06c-4.41,0-8.83-.12-13.24-.17H82.4V58c0-1.9.08-3.79.13-5.65Zm0,0,.14,5.65c.05,1.87.11,3.71.13,5.54l-.27-.27c4.41-.06,8.83-.16,13.24-.17l13.24-.06-.5.5.06-11.19.44.44c-2.18,0-4.36,0-6.54,0L96,47.1Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,193.07l13.13-.27,6.66-.12c2.23,0,4.46,0,6.69-.05H134v.44l.05,11.19v.51h-.51l-13.24-.06c-4.41,0-8.82-.11-13.24-.16h-.27v-.27c0-1.89.09-3.78.13-5.65Zm0,0,.15,5.66c0,1.86.11,3.7.13,5.53L107,204c4.42-.05,8.83-.16,13.24-.16l13.24-.07-.5.5.06-11.19.44.45c-2.18,0-4.35,0-6.54-.05l-6.58-.12Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.82,179l13.12-.27,6.66-.12c2.23,0,4.46,0,6.7,0h.44V179l.06,11.19v.51h-.5l-13.24-.06c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.89.09-3.78.13-5.65Zm0,0,.14,5.66c0,1.86.11,3.7.13,5.53l-.27-.27c4.41,0,8.82-.16,13.24-.16l13.24-.07-.5.5,0-11.19.45.45c-2.19,0-4.36,0-6.55,0l-6.58-.12Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.14,46.82l13.12-.28,6.66-.11c2.23,0,4.47,0,6.7-.06h.44v.45L80.12,58v.5h-.5l-13.24-.06c-4.42,0-8.83-.12-13.24-.17h-.28V58c0-1.9.09-3.79.13-5.65Zm0,0,.14,5.65c0,1.87.11,3.71.13,5.54l-.27-.27c4.41-.06,8.82-.16,13.24-.17l13.24-.06-.5.5,0-11.19.45.44c-2.18,0-4.36,0-6.55,0l-6.58-.11Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.39,84l-13.13.28-6.66.11c-2.23,0-4.46,0-6.69.06h-.45V84l0-11.19v-.5h.51l13.24.06c4.41,0,8.82.12,13.24.17h.27v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.15-5.65c0-1.87-.11-3.71-.13-5.54l.28.27c-4.42.06-8.83.16-13.24.17l-13.24.06.49-.5,0,11.19-.44-.44c2.18,0,4.35,0,6.54,0l6.58.11Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.09,289.84l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.71-.13-5.54l.27.27c-4.41.06-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.58.11Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.86,304l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44V304l-.06-11.19v-.5h.5l13.24.07c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41.06-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.58.11Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.62,304l-13.13.28-6.66.11c-2.23.05-4.46,0-6.69.06h-.45V304l0-11.19v-.5h.51l13.24.07c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.15-5.65c0-1.87-.11-3.71-.13-5.54l.28.27c-4.42.06-8.83.16-13.24.17l-13.24.06.49-.5,0,11.19-.44-.44c2.18,0,4.35,0,6.54.05l6.58.11Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.5,46.82l13.12-.28,6.66-.11c2.23,0,4.47,0,6.7-.06h.44v.45L682.48,58v.5H682l-13.24-.06c-4.42,0-8.83-.12-13.24-.17h-.28V58c0-1.9.09-3.79.14-5.65Zm0,0,.14,5.65c0,1.87.11,3.71.13,5.54l-.27-.27c4.41-.06,8.82-.16,13.24-.17L682,57.51l-.5.5,0-11.19.45.44c-2.18,0-4.36,0-6.55,0l-6.58-.11Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.13 339.92 646.02 339.92 649.91 263.23 455.24 263.23 459.13 339.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.74,338.9H608.6l-1.46-26.62h81.31ZM609.5,338h76.35l1.59-24.74H608.13Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.3,369.53H611.66l-1.19-24H686.8Zm-72.74-.94h71.85l1.38-22.15H611.46Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.19,328.48H642.06l-.82-6.43H656Zm-12.3-1h11.47L655,323H642.31Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.19,360.72H642.06l-.82-6.42H656Zm-12.3-.94h11.47l.59-4.53H642.31Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.83,338.9H516.69l-1.46-26.62h81.31ZM517.59,338H594l1.58-24.74H516.22Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.39,369.53H519.75l-1.19-24h76.33Zm-72.74-.94H592.5l1.39-22.15H519.55Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.29,328.48H550.16l-.83-6.43h14.78Zm-12.31-1h11.48L563,323H550.4Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.29,360.72H550.16l-.83-6.42h14.78ZM551,359.78h11.48l.58-4.53H550.4Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.89 339.92 474.71 348.27 472.35 365.06 467.74 365.06 467.74 339.92 475.89 339.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.89 339.92 474.71 348.27 467.74 348.27 467.74 339.92 475.89 339.92",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.26 339.92 630.44 348.27 632.8 365.06 637.41 365.06 637.41 339.92 629.26 339.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.26 339.92 630.44 348.27 637.41 348.27 637.41 339.92 629.26 339.92",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.57,161.75H79V47.24H205.58v72.67C205.58,130.17,205.57,161.75,205.57,161.75Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.57,161.75,142.4,162,79,162.09H78.7v-.34L78.54,47.24v-.5H79l126.54.16h.34v.34l-.13,57.25Zm0,0-.32-114.51.33.33L79,47.73l.5-.49-.17,114.51-.33-.33,63.17.11Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.47,
    y: 6.67,
    width: 126.53,
    height: 21.69,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.74,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.68,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.62,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.56,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.44,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.38,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.32,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.27,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.21,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.15,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.09,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.03,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.97,
    y: 1.64,
    width: 2.71,
    height: 10.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 37.77,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.53,
    y: 37.77,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.58,
    y: 37.77,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.64,
    y: 37.77,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.69,
    y: 37.77,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.74,
    y: 37.77,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.8,
    y: 37.77,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 52.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.53,
    y: 52.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.58,
    y: 52.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.64,
    y: 52.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.69,
    y: 52.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.74,
    y: 52.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.8,
    y: 52.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 67.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.53,
    y: 67.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.58,
    y: 67.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.64,
    y: 67.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.69,
    y: 67.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.74,
    y: 67.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.8,
    y: 67.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 82.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.53,
    y: 82.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.58,
    y: 82.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.64,
    y: 82.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.69,
    y: 82.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.74,
    y: 82.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.8,
    y: 82.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.48,
    y: 97.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.53,
    y: 97.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.58,
    y: 97.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.64,
    y: 97.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.69,
    y: 97.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.74,
    y: 97.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.8,
    y: 97.76,
    width: 14.2,
    height: 14.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.85,76.93a.11.11,0,0,1,.16,0,.76.76,0,0,0,.43.18.49.49,0,0,0,.28-.09.21.21,0,0,0,.09-.16.25.25,0,0,0,0-.07.14.14,0,0,0-.07-.06.79.79,0,0,0-.3-.11h0a1.11,1.11,0,0,1-.29-.08.52.52,0,0,1-.21-.18.35.35,0,0,1,0-.18.41.41,0,0,1,.18-.32.62.62,0,0,1,.38-.12.84.84,0,0,1,.49.18.11.11,0,0,1,0,.15.12.12,0,0,1-.16,0,.6.6,0,0,0-.36-.14.43.43,0,0,0-.24.07c-.06,0-.09.09-.09.14a.08.08,0,0,0,0,.06.17.17,0,0,0,.06.06.64.64,0,0,0,.27.1h0a1.18,1.18,0,0,1,.3.09.54.54,0,0,1,.23.19.37.37,0,0,1,.05.18.43.43,0,0,1-.19.35.69.69,0,0,1-.41.12,1,1,0,0,1-.57-.22A.12.12,0,0,1,94.85,76.93Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,77.32a.64.64,0,0,1-.64-.64v-.79a.13.13,0,0,1,.12-.13.13.13,0,0,1,.13.13v.79a.4.4,0,0,0,.79,0v-.79a.12.12,0,1,1,.24,0v.79A.64.64,0,0,1,97,77.32Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.39,77.19a.12.12,0,0,1-.12.13.13.13,0,0,1-.12-.13V75.91h0a.16.16,0,0,1,0-.1.13.13,0,0,1,.17,0l.72,1v-.91a.12.12,0,0,1,.12-.12.12.12,0,0,1,.12.12v1.28a.13.13,0,0,1-.12.13.14.14,0,0,1-.1,0h0l-.71-1Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.12,75.89v1.3a.13.13,0,0,1-.13.13.12.12,0,0,1-.12-.13v-.93l-.32.44a.11.11,0,0,1-.1.06h0a.14.14,0,0,1-.11-.06l-.31-.44v.93a.13.13,0,0,1-.13.13.13.13,0,0,1-.12-.13v-1.3a.13.13,0,0,1,.12-.13h0a.12.12,0,0,1,.1,0l.44.62.44-.62a.12.12,0,0,1,.1,0h0A.14.14,0,0,1,111.12,75.89Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.78,76a.83.83,0,0,1,.22.56.85.85,0,0,1-.22.56.75.75,0,0,1-.53.24.78.78,0,0,1-.55-.24.8.8,0,0,1-.22-.56.79.79,0,0,1,.22-.56.74.74,0,0,1,.55-.24A.71.71,0,0,1,112.78,76Zm0,.56a.59.59,0,0,0-.15-.39.5.5,0,0,0-.35-.16.47.47,0,0,0-.36.16.54.54,0,0,0-.15.39.5.5,0,0,0,.15.38.47.47,0,0,0,.36.16.5.5,0,0,0,.35-.16A.55.55,0,0,0,112.75,76.52Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.62,77.19a.12.12,0,1,1-.24,0V75.91h0a.16.16,0,0,1,.05-.1.13.13,0,0,1,.17,0l.71,1v-.91a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v1.28a.13.13,0,0,1-.13.13.12.12,0,0,1-.09,0h0l-.71-1Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.22,76h-.36v1.18a.12.12,0,1,1-.24,0V76h-.35a.12.12,0,0,1-.12-.12.12.12,0,0,1,.12-.13h1a.13.13,0,0,1,.12.13A.13.13,0,0,1,126.22,76Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.35,77.32a.65.65,0,0,1-.65-.64v-.79a.13.13,0,0,1,.13-.13.13.13,0,0,1,.12.13v.79a.4.4,0,0,0,.79,0v-.79a.13.13,0,0,1,.12-.13.13.13,0,0,1,.13.13v.79A.64.64,0,0,1,127.35,77.32Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.39,77.19v-1.3a.13.13,0,0,1,.13-.13h.72a.12.12,0,0,1,.12.13.12.12,0,0,1-.12.12h-.6v.41h.52a.12.12,0,0,1,0,.24h-.52v.41h.6a.12.12,0,0,1,.12.12.12.12,0,0,1-.12.13h-.72A.13.13,0,0,1,128.39,77.19Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.93,76l-.54,1.29a0,0,0,0,1,0,0h0s0,0,0,0h0l0,0h-.1l0,0h0v0h0v0l-.29-.69-.3.69v0h0v0h0l0,0h-.09a0,0,0,0,1,0,0h0a0,0,0,0,1,0,0h0v0h0a0,0,0,0,0,0,0L139.82,76a.12.12,0,0,1,.06-.16.12.12,0,0,1,.16.06l.43,1,.29-.68a.12.12,0,0,1,.12-.07.12.12,0,0,1,.11.07l.29.68.43-1a.12.12,0,0,1,.16-.06A.12.12,0,0,1,141.93,76Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.29,77.19v-1.3a.12.12,0,0,1,.12-.13h.72a.13.13,0,0,1,.13.13.13.13,0,0,1-.13.12h-.6v.41h.52a.12.12,0,0,1,0,.24h-.52v.41h.6a.13.13,0,0,1,.13.12.13.13,0,0,1-.13.13h-.72A.12.12,0,0,1,142.29,77.19Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.6,77.19v-1.3a.12.12,0,0,1,.12-.13H144a.78.78,0,1,1,0,1.56h-.26A.12.12,0,0,1,143.6,77.19Zm.25-.12H144A.53.53,0,0,0,144,76h-.13Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.14,76h-.35v1.18a.13.13,0,0,1-.13.13.13.13,0,0,1-.12-.13V76h-.35a.12.12,0,0,1-.12-.12.12.12,0,0,1,.12-.13h.95a.13.13,0,0,1,.12.13A.13.13,0,0,1,156.14,76Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.63,77.19v-1.3a.12.12,0,1,1,.24,0v.53h.58v-.53a.12.12,0,1,1,.24,0v1.3a.12.12,0,1,1-.24,0v-.53h-.58v.53a.12.12,0,1,1-.24,0Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.84,77.32a.64.64,0,0,1-.64-.64v-.79a.12.12,0,1,1,.24,0v.79a.4.4,0,0,0,.4.39.39.39,0,0,0,.39-.39v-.79a.13.13,0,0,1,.13-.13.12.12,0,0,1,.12.13v.79A.64.64,0,0,1,158.84,77.32Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,77.19v-1.3a.12.12,0,0,1,.12-.13h.72a.13.13,0,0,1,.13.13.13.13,0,0,1-.13.12h-.6v.41h.52a.12.12,0,1,1,0,.24h-.52v.53a.12.12,0,1,1-.24,0Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32,77.13a.13.13,0,0,1-.08.16h-.05a.15.15,0,0,1-.09,0,.27.27,0,0,1-.07-.08.57.57,0,0,1-.05-.26.22.22,0,0,0,0-.1s0,0-.07-.06l-.12-.06h-.27v.48a.12.12,0,1,1-.24,0v-1.3a.12.12,0,0,1,.12-.13h.4a.48.48,0,0,1,.47.48.46.46,0,0,1-.17.36l.08.09a.43.43,0,0,1,.07.24.45.45,0,0,0,0,.13A.13.13,0,0,1,173.32,77.13Zm-.32-.89a.22.22,0,0,0-.22-.23h-.28v.46h.28A.23.23,0,0,0,173,76.24Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.69,75.89a.12.12,0,1,1,.24,0v1.3a.12.12,0,1,1-.24,0Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.61,76.93a.11.11,0,0,1,.16,0,.76.76,0,0,0,.42.18.49.49,0,0,0,.28-.09.19.19,0,0,0,.1-.16.25.25,0,0,0,0-.07l-.07-.06a.86.86,0,0,0-.3-.11h0a1.38,1.38,0,0,1-.29-.08.49.49,0,0,1-.2-.18.35.35,0,0,1-.05-.18.38.38,0,0,1,.18-.32.6.6,0,0,1,.38-.12.81.81,0,0,1,.48.18.1.1,0,0,1,0,.15.1.1,0,0,1-.15,0,.65.65,0,0,0-.36-.14.46.46,0,0,0-.25.07.17.17,0,0,0-.08.14s0,0,0,.06a.17.17,0,0,0,.06.06.75.75,0,0,0,.28.1h0a1.26,1.26,0,0,1,.31.09.51.51,0,0,1,.22.19.37.37,0,0,1,0,.18.43.43,0,0,1-.19.35.69.69,0,0,1-.41.12.9.9,0,0,1-.56-.22A.11.11,0,0,1,185.61,76.93Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.89,77h-.54l-.1.29a.13.13,0,0,1-.12.08h0a.13.13,0,0,1-.08-.16l.49-1.31a.14.14,0,0,1,.24,0l.49,1.31a.13.13,0,0,1-.07.16h0a.13.13,0,0,1-.11-.08Zm-.09-.24-.18-.48-.18.48Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.26,76h-.35v1.18a.13.13,0,0,1-.12.13.13.13,0,0,1-.13-.13V76h-.35a.12.12,0,0,1-.12-.12.12.12,0,0,1,.12-.13h.95a.12.12,0,0,1,.12.13A.12.12,0,0,1,189.26,76Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.48,
    y: 44.87,
    width: 56.6,
    height: 68.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.95,
    y: 51.13,
    width: 43.66,
    height: 56.12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.95,
    y: 51.13,
    width: 1.7,
    height: 56.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.08,
    y: 44.87,
    width: 1.7,
    height: 68.65,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.58,
    y: 58.87,
    width: 10.3,
    height: 30.67,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.62,135.85H657.16v-16h28.46Zm-27.46-1h26.46v-14H658.16Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.19,
    y: 137.95,
    width: 56.6,
    height: 68.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.65,
    y: 144.22,
    width: 43.66,
    height: 56.12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.65,
    y: 144.22,
    width: 1.7,
    height: 56.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.78,
    y: 137.95,
    width: 1.7,
    height: 68.65,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.26,
    y: 158.72,
    width: 8.82,
    height: 22.3,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.43,228.71H630.74V212.34h24.69Zm-23.69-1h22.69V213.34H631.74Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.08,320.49A68.06,68.06,0,0,0,103.87,333c.12.21.09,1,0,.77,0,.68-1.07.56-1.07-.12,0-.44,0-.88,0-1.31-2.43-3-6-4.94-8.83-7.57a16.51,16.51,0,0,1-4.84-7.7c-2.37-8.18-.15-16.84-3-25-2.46-7-6.88-13.14-10.61-19.51-3.94-6.74-6.85-13.81-7.14-21.7-.23-6,.49-14.1,5.09-18.62,4.88-4.81,10.93-1.21,14.66,3.08C99,247.7,104,263.41,106,279.47c1.11,8.88,2.27,17.83,2,26.8A73.29,73.29,0,0,1,106.08,320.49Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.92,336.22a152.3,152.3,0,0,0-.3-25.18.15.15,0,0,0,0-.09c.14-6.81.68-13.58.41-20.4a121.37,121.37,0,0,0-3-21.88c0-.08-.15-.06-.13,0a142.54,142.54,0,0,1,2.36,21.4q.21,5.78-.09,11.54c-.06,1.25-.18,2.51-.26,3.77v0A134.81,134.81,0,0,0,82.71,251.8c-.15-.22-.54,0-.4.24a139.65,139.65,0,0,1,16.48,39.73c-5.2-9.64-13.07-17.58-18.91-26.85,0-.05-.11,0-.08.06C85,275.3,93.7,283.43,99.22,293.6q1.44,6.22,2.32,12.54a139.08,139.08,0,0,1,1.26,17.41c-3.17-5.92-6.46-11.6-9.06-17.87-.07-.16-.31-.05-.25.12,2.21,6.51,5.17,13.53,9.33,19.08q0,6.18-.35,12.37c-.64,11-2.52,21.83-3.39,32.79a.25.25,0,0,0,.5.06A250.72,250.72,0,0,0,103.92,336.22Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.25,251.45a.07.07,0,1,0-.12.05c2,5.55,3.14,11.18,4.59,16.87a.21.21,0,0,0,.41-.07C96.54,262.53,94.48,256.77,92.25,251.45Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23,274.72a82.14,82.14,0,0,1-4.62,9.48c-3.61,6.57-7.38,12.58-8.06,20.23-.31,3.41-.42,6.84-1.46,10.13a30.28,30.28,0,0,1-4,7.93c-3.92,5.71-8.81,10.63-12.44,16.55A69.49,69.49,0,0,0,104.34,359c-.09.38-.7.28-.61-.11a.24.24,0,0,0,0-.08.15.15,0,0,1,0-.08c-.58-16.4.73-32.92,5.73-48.62a167.92,167.92,0,0,1,7.94-20.22c2.68-5.7,6-11.17,10.72-15.43,3-2.75,9.67-7.95,14-5.2C144.21,270.58,144.05,272.67,143.23,274.72Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.76,311.88a134.42,134.42,0,0,1-9.53,13.69c-1.59,2.07-3.2,4.13-4.78,6.2-.75,1-1.59,2-2.27,3,.43-1.72.85-3.45,1.29-5.17,2.11-8.28,4.15-16.64,7.3-24.6a166,166,0,0,1,11.38-22.31c.11-.19-.2-.33-.31-.15-3.46,5.7-7,11.39-9.89,17.39a93,93,0,0,0-4.2,10.32,159.89,159.89,0,0,1,5.59-22c0-.07-.07-.12-.1-.05a75.62,75.62,0,0,0-5.8,22.93s0,0,0,0c-.71,2.13-1.36,4.28-2,6.44-2.58,9.17-4.85,18.44-7,27.74a99.62,99.62,0,0,1,1.58-18.23c0-.14-.18-.17-.21,0a57.57,57.57,0,0,0-1.59,19.21q-1.19,5.31-2.32,10.62c-1.61,7.56-3.59,15.25-4.53,22.92a.15.15,0,0,0,.3.05c1.12-4.13,1.8-8.42,2.72-12.61s1.88-8.39,2.85-12.58q2.15-9.15,4.44-18.26c1-2.23,3-4.2,4.45-6.07,1.61-2,3.22-4.1,4.79-6.19A91.71,91.71,0,0,0,126.9,312,.08.08,0,1,0,126.76,311.88Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.46,304.87a85,85,0,0,0-9.33,14.81c0,.07.08.14.12.07,3.13-4.91,6.22-9.87,9.35-14.79C127.65,304.88,127.52,304.79,127.46,304.87Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.67,290.26c2.13,3.66,4.55,8.05,3.64,12.44-.58,2.78-2.61,5-3,7.88-.82,6.26,5.42,10.4,9.93,13.36C79.52,331.32,95,337.91,97,353c.08.53,1,.4.94-.12a.3.3,0,0,0,0-.1s0,0,0-.09a57.85,57.85,0,0,0-.21-23c-1.68-7.77-5.07-14.76-9.08-21.59-6.77-11.55-13.94-23.39-24.19-32.24-2.83-2.45-8.64-6.85-10.9-1.32C51.4,279.86,55.07,285.8,57.67,290.26Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,314.76c7.46,8.08,19.32,12.61,25.75,21.66a90.76,90.76,0,0,0-19.79-37.18.29.29,0,0,1,.41-.41,73.33,73.33,0,0,1,16.17,23.42,104.84,104.84,0,0,0-7-17.81.19.19,0,0,1,.33-.19,67.83,67.83,0,0,1,7.5,20c8.47,20.49,9.25,44.52,7.48,66.12,0,.31-.5.32-.49,0,.49-17,.21-34.34-3.87-51-.08-.35-.18-.69-.26-1-7-9.74-18.81-14.26-26.4-23.51C67.78,314.8,67.9,314.67,68,314.76Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.25,307.82c3.92,3.6,7.77,7.27,11.7,10.86,0,0,0,.11-.06.08A57.36,57.36,0,0,1,66,308.05.17.17,0,0,1,66.25,307.82Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.63,292.25a123.47,123.47,0,0,0,11.72,16.12.07.07,0,0,1-.1.1,56.63,56.63,0,0,1-11.83-16.1A.12.12,0,0,1,65.63,292.25Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.7 365.06 68.01 365.06 63.39 318.89 38.98 318.89 33.7 365.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.12 326.4 64.14 326.4 63.39 318.89 38.98 318.89 38.12 326.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.34,
    y: 354.34,
    width: 32.17,
    height: 7.37,
    transform: "translate(151.28 675.49) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.24 365.06 81.53 364.82 162.83 364.73 325.43 364.56 488.02 364.73 569.32 364.82 650.62 365.06 569.32 365.31 488.02 365.39 325.43 365.56 162.83 365.39 81.53 365.31 0.24 365.06",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 33.81,
    width: 495.11,
    height: 331.25,
    rx: 12.89,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.87,
    y1: 48.17,
    x2: 146.87,
    y2: 47.4,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.36,
    y: 47.79,
    width: 426.11,
    height: 302.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.24,
    y: 163.39,
    width: 5.15,
    height: 72.09,
    rx: 1.25,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 608.78,
    cy: 240,
    r: 9.32,
    transform: "translate(185.25 736.43) rotate(-76.66)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.36,
    y: 47.79,
    width: 426.11,
    height: 302.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.36,
    y: 47.79,
    width: 426.11,
    height: 10.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.14,93.55A2.13,2.13,0,1,1,172,91.42,2.13,2.13,0,0,1,174.14,93.55Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.15,
    cy: 52.99,
    r: 2.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.86,
    cy: 52.99,
    r: 2.13,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.75,
    y: 220.93,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.75,
    y: 220.93,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.11,
    y: 220.93,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.71,
    y: 220.93,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.19,
    y: 220.93,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.67,
    y: 220.93,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.14,
    y: 220.93,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.14,
    y: 220.93,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.62,
    y: 220.93,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.75,
    y: 250.83,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.75,
    y: 250.83,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.23,
    y: 250.83,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.71,
    y: 250.83,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.19,
    y: 250.83,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.67,
    y: 250.83,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.14,
    y: 250.83,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.62,
    y: 250.83,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.19,
    y: 191.04,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.67,
    y: 191.04,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.14,
    y: 191.04,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.62,
    y: 191.04,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.75,
    y: 280.73,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.75,
    y: 280.73,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.23,
    y: 280.73,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.71,
    y: 280.73,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.19,
    y: 280.73,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.19,
    y: 280.73,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.67,
    y: 280.73,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.14,
    y: 280.73,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.62,
    y: 280.73,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.75,
    y: 310.62,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.75,
    y: 310.62,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.23,
    y: 310.62,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.71,
    y: 310.62,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.19,
    y: 310.62,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.67,
    y: 310.62,
    width: 27.78,
    height: 21.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.56,216.18a.92.92,0,0,1,1.3-.12,5.93,5.93,0,0,0,3.43,1.38,3.84,3.84,0,0,0,2.24-.67,1.62,1.62,0,0,0,.77-1.29,1,1,0,0,0-.17-.57,1.57,1.57,0,0,0-.53-.54,7.26,7.26,0,0,0-2.46-.84h0a9.62,9.62,0,0,1-2.31-.7,3.76,3.76,0,0,1-1.67-1.4,2.72,2.72,0,0,1-.41-1.46,3.32,3.32,0,0,1,1.43-2.62,5.3,5.3,0,0,1,3.1-.95,7.06,7.06,0,0,1,3.91,1.43.93.93,0,0,1,.25,1.27.91.91,0,0,1-1.28.27,5.17,5.17,0,0,0-2.88-1.14,3.43,3.43,0,0,0-2,.61,1.42,1.42,0,0,0-.68,1.13.89.89,0,0,0,.13.5,1.77,1.77,0,0,0,.48.46,6.25,6.25,0,0,0,2.24.79h0a10.69,10.69,0,0,1,2.47.75,4.23,4.23,0,0,1,1.79,1.49,2.9,2.9,0,0,1,.43,1.52,3.45,3.45,0,0,1-1.54,2.78,5.56,5.56,0,0,1-3.31,1,7.71,7.71,0,0,1-4.59-1.79A.94.94,0,0,1,205.56,216.18Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.09,207.74v10.57a1,1,0,0,1-1,1,1,1,0,0,1-1-1v-7.54l-2.58,3.58a1,1,0,0,1-.81.42h0a1,1,0,0,1-.82-.42l-2.56-3.58v7.54a1,1,0,0,1-2,0V207.74a1,1,0,0,1,1-1h.06a1,1,0,0,1,.79.41l3.56,5,3.57-5a1,1,0,0,1,.8-.41h0A1,1,0,0,1,251.09,207.74Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.69,208.75h-2.85v9.56a1,1,0,0,1-1,1,1,1,0,0,1-1-1v-9.56H279a1,1,0,0,1-1-1,1,1,0,0,1,1-1h7.65a1,1,0,0,1,1,1A1,1,0,0,1,286.69,208.75Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.52,208.24l-4.39,10.45a.61.61,0,0,1-.09.16l0,0a.87.87,0,0,1-.09.11s0,0,0,.05l-.12.09h0c-.06,0-.09.09-.16.11h0a0,0,0,0,0,0,0l-.14,0h0a.5.5,0,0,1-.18,0,.44.44,0,0,1-.16,0H321l-.13,0,0,0a.36.36,0,0,1-.17-.11h0c-.06,0-.09-.07-.13-.09a.09.09,0,0,1,0-.05s-.06-.07-.08-.11,0,0,0,0a.29.29,0,0,1-.07-.16L318,213.14l-2.35,5.55a1.26,1.26,0,0,1-.07.16,0,0,0,0,0,0,0,1.14,1.14,0,0,1-.11.11s0,0,0,.05a.48.48,0,0,0-.11.09h0a1.1,1.1,0,0,1-.14.11h0a0,0,0,0,0,0,0,.26.26,0,0,0-.14,0h-.05a.47.47,0,0,1-.16,0,.52.52,0,0,1-.18,0h-.06l-.12,0s0,0,0,0a.57.57,0,0,1-.16-.11h0s-.07-.07-.12-.09l0-.05-.09-.11v0s0-.11-.09-.16l-4.41-10.45a1,1,0,0,1,.54-1.27,1,1,0,0,1,1.27.52l3.52,8.3,2.31-5.5a1,1,0,0,1,.93-.61,1,1,0,0,1,.93.61l2.31,5.5,3.5-8.3A1,1,0,0,1,326,207,1,1,0,0,1,326.52,208.24Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,208.75H356.1v9.56a1,1,0,0,1-1,1,1,1,0,0,1-1-1v-9.56H351.3a1,1,0,0,1-1-1,1,1,0,0,1,1-1H359a1,1,0,0,1,1,1A1,1,0,0,1,359,208.75Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,218.31V207.74a1,1,0,0,1,1-1h5.86a1,1,0,0,1,0,2H390V212h4.18a1,1,0,0,1,0,2H390v4.3a1,1,0,0,1-1,1A1,1,0,0,1,388,218.31Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.34,216.18a.93.93,0,0,1,1.31-.12,5.9,5.9,0,0,0,3.42,1.38,3.84,3.84,0,0,0,2.24-.67,1.6,1.6,0,0,0,.77-1.29,1.08,1.08,0,0,0-.16-.57,1.72,1.72,0,0,0-.54-.54,7.26,7.26,0,0,0-2.46-.84h0a9.76,9.76,0,0,1-2.31-.7,3.87,3.87,0,0,1-1.67-1.4,2.72,2.72,0,0,1-.41-1.46,3.32,3.32,0,0,1,1.43-2.62,5.3,5.3,0,0,1,3.1-.95,7.06,7.06,0,0,1,3.91,1.43.92.92,0,0,1,.25,1.27.9.9,0,0,1-1.27.27,5.2,5.2,0,0,0-2.89-1.14,3.45,3.45,0,0,0-2,.61,1.42,1.42,0,0,0-.68,1.13.89.89,0,0,0,.13.5,1.77,1.77,0,0,0,.48.46,6.32,6.32,0,0,0,2.24.79h0a10.54,10.54,0,0,1,2.47.75,4.17,4.17,0,0,1,1.79,1.49,2.9,2.9,0,0,1,.43,1.52,3.45,3.45,0,0,1-1.54,2.78,5.56,5.56,0,0,1-3.31,1,7.71,7.71,0,0,1-4.59-1.79A1,1,0,0,1,423.34,216.18Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,275.94a.28.28,0,0,1,0-.4.3.3,0,0,1,.41,0,2.12,2.12,0,0,0,3,0,2.15,2.15,0,0,0,0-3,2.16,2.16,0,0,0-3,0,.27.27,0,0,1-.39,0,.15.15,0,0,1-.07-.09h0s0,0,0,0a.22.22,0,0,1,0-.09.43.43,0,0,0,0-.05l.38-3.21a.33.33,0,0,1,.3-.27h3.7a.29.29,0,1,1,0,.57h-3.46l-.29,2.36a2.69,2.69,0,0,1,1.36-.36,2.68,2.68,0,0,1,2.68,2.69,2.65,2.65,0,0,1-.79,1.91,2.7,2.7,0,0,1-3.82,0Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.7,270.51a3.2,3.2,0,0,1,2.78-1.73.27.27,0,0,1,.28.26.3.3,0,0,1-.27.3,2.69,2.69,0,0,0-2.32,1.44,5.47,5.47,0,0,0-.57,1.59,2.62,2.62,0,1,1-.66,1.82,4.43,4.43,0,0,1,0-.52A6.49,6.49,0,0,1,243.7,270.51Zm-.2,3.64a.59.59,0,0,0,0,.14.17.17,0,0,1,0,.08,2.13,2.13,0,1,0,0-.27Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.8,276.34l2.95-7H279.9a.28.28,0,0,1,0-.55h4.21a.26.26,0,0,1,.32.19.24.24,0,0,1,0,.09.23.23,0,0,1,0,.14l-3.08,7.33a.3.3,0,0,1-.26.17.17.17,0,0,1-.11,0A.29.29,0,0,1,280.8,276.34Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,268.77a1.66,1.66,0,0,1,1.66,1.65,1.7,1.7,0,0,1-.68,1.34,2.58,2.58,0,1,1-2,0,1.69,1.69,0,0,1-.66-1.34A1.65,1.65,0,0,1,318,268.77Zm0,7.41a2,2,0,1,0-2-2A2,2,0,0,0,318,276.18Zm0-4.64a1.13,1.13,0,0,0,1.11-1.12,1.11,1.11,0,0,0-1.11-1.11,1.09,1.09,0,0,0-1.1,1.11A1.11,1.11,0,0,0,318,271.54Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.92,268.77a2.61,2.61,0,0,1,2.61,2.32.13.13,0,0,0,0,.05c0,.22,0,.45,0,.69a6.68,6.68,0,0,1-.76,3.17,3.32,3.32,0,0,1-2.79,1.73h0a.27.27,0,0,1-.28-.27.29.29,0,0,1,.27-.29,2.73,2.73,0,0,0,2.32-1.44,5.35,5.35,0,0,0,.57-1.6,2.63,2.63,0,1,1-2-4.36Zm2.08,2.61a2.08,2.08,0,1,0-2.08,2.07A2.06,2.06,0,0,0,357,271.38Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.72,269.58l-1.12.65a.24.24,0,0,1-.14,0,.29.29,0,0,1-.24-.14.26.26,0,0,1,.1-.37l1.54-.93a.28.28,0,0,1,.37.1.29.29,0,0,1,0,.2v7.31a.28.28,0,0,1-.28.28.28.28,0,0,1-.27-.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.35,272.75a5.07,5.07,0,0,1,.76-2.79,2.26,2.26,0,0,1,4,0,5.16,5.16,0,0,1,.77,2.79,5.07,5.07,0,0,1-.77,2.77,2.24,2.24,0,0,1-4,0A5,5,0,0,1,391.35,272.75Zm.56,0a4.49,4.49,0,0,0,.67,2.46,1.68,1.68,0,0,0,3,0,4.75,4.75,0,0,0,0-4.93,1.69,1.69,0,0,0-3,0A4.5,4.5,0,0,0,391.91,272.75Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.48,269.58l-1.13.65a.21.21,0,0,1-.13,0,.27.27,0,0,1-.24-.14.26.26,0,0,1,.1-.37l1.53-.93a.29.29,0,0,1,.38.1.35.35,0,0,1,0,.2v7.31a.27.27,0,0,1-.27.28.28.28,0,0,1-.27-.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.29,269.58l-1.13.65a.21.21,0,0,1-.13,0,.27.27,0,0,1-.24-.14.26.26,0,0,1,.1-.37l1.53-.93a.29.29,0,0,1,.38.1.35.35,0,0,1,0,.2v7.31a.27.27,0,0,1-.27.28.28.28,0,0,1-.27-.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.45,239.16l-1.12.66a.33.33,0,0,1-.14,0,.28.28,0,0,1-.24-.13.27.27,0,0,1,.1-.38l1.54-.93a.28.28,0,0,1,.37.1.32.32,0,0,1,0,.21V246a.28.28,0,0,1-.27.27.28.28,0,0,1-.28-.27Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.51,245.82l3.71-3.35a2.06,2.06,0,0,0,.69-1.53,2.06,2.06,0,0,0-2.05-2,2.09,2.09,0,0,0-1.39.52l-.38.35a.26.26,0,0,1-.39,0,.26.26,0,0,1,0-.38l.39-.37a2.67,2.67,0,0,1,1.76-.67,2.56,2.56,0,0,1,1.91.85,2.52,2.52,0,0,1,.68,1.74,2.63,2.63,0,0,1-.85,1.94l-3.18,2.87h3.76a.28.28,0,0,1,.27.29.28.28,0,0,1-.27.27H352.7a.23.23,0,0,1-.2-.08A.29.29,0,0,1,352.51,245.82Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.28,238.85,392.22,241a2.66,2.66,0,0,1,1.36.72,2.69,2.69,0,0,1,.79,1.91,2.62,2.62,0,0,1-.8,1.91,2.68,2.68,0,0,1-1.91.8,2.65,2.65,0,0,1-1.9-.8.27.27,0,0,1,0-.39.27.27,0,0,1,.4,0,2.16,2.16,0,0,0,3,0,2.14,2.14,0,0,0,.63-1.52,2.1,2.1,0,0,0-.63-1.5,2.07,2.07,0,0,0-1.5-.62.27.27,0,0,1-.22-.12h0a.28.28,0,0,1,0-.4l2-2h-3a.28.28,0,0,1-.29-.28.29.29,0,0,1,.29-.29h3.71a.29.29,0,0,1,.29.29.17.17,0,0,1,0,.12A.19.19,0,0,1,394.28,238.85Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.51,244.67h-4.34a.25.25,0,0,1-.17,0,.27.27,0,0,1,0-.39l4.61-5.73h0a.25.25,0,0,1,.38,0,.37.37,0,0,1,.09.14.43.43,0,0,0,0,0v5.49h.54a.27.27,0,1,1,0,.54h-.54V246a.28.28,0,0,1-.55,0Zm0-.54v-4.66l-3.76,4.66Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.67,329.08l-1.13.66a.29.29,0,0,1-.13.05.27.27,0,0,1-.24-.14.25.25,0,0,1,.1-.37l1.54-.94a.29.29,0,0,1,.37.11.28.28,0,0,1,0,.2V336a.26.26,0,0,1-.27.27.27.27,0,0,1-.27-.27Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.93,328.28a2.62,2.62,0,0,1,2.62,2.31l0,.06c0,.22,0,.44,0,.68a6.51,6.51,0,0,1-.76,3.17,3.26,3.26,0,0,1-2.78,1.73h0a.27.27,0,0,1-.29-.26.29.29,0,0,1,.27-.29,2.7,2.7,0,0,0,2.32-1.45,4.8,4.8,0,0,0,.57-1.59,2.59,2.59,0,0,1-2,.88,2.62,2.62,0,1,1,0-5.24Zm2.08,2.61a2.07,2.07,0,1,0-2.08,2.07A2.06,2.06,0,0,0,213,330.89Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.31,335.74l3.71-3.35a2,2,0,0,0,.69-1.52,2.06,2.06,0,0,0-.54-1.37,2.06,2.06,0,0,0-2.9-.14l-.38.35a.28.28,0,1,1-.38-.4l.39-.36a2.64,2.64,0,0,1,1.76-.67,2.61,2.61,0,0,1,2.59,2.59,2.61,2.61,0,0,1-.85,1.93l-3.18,2.88H244a.28.28,0,0,1,0,.55H239.5a.23.23,0,0,1-.2-.08A.29.29,0,0,1,239.31,335.74Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.14,332.25a5.15,5.15,0,0,1,.76-2.78,2.26,2.26,0,0,1,4,0,5.34,5.34,0,0,1,0,5.56,2.25,2.25,0,0,1-4,0A5.1,5.1,0,0,1,246.14,332.25Zm.56,0a4.5,4.5,0,0,0,.67,2.47,1.69,1.69,0,0,0,3,0,4.81,4.81,0,0,0,0-4.93,1.69,1.69,0,0,0-3,0A4.49,4.49,0,0,0,246.7,332.25Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.8,335.74l3.72-3.35a2,2,0,0,0-1.37-3.56,2,2,0,0,0-1.38.53l-.39.35a.27.27,0,0,1-.39,0,.26.26,0,0,1,0-.39l.38-.36a2.64,2.64,0,0,1,1.76-.67,2.62,2.62,0,0,1,2.6,2.59,2.62,2.62,0,0,1-.86,1.93l-3.18,2.88h3.76a.28.28,0,1,1,0,.55H278a.23.23,0,0,1-.2-.08A.31.31,0,0,1,277.8,335.74Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.82,329.08l-1.13.66a.29.29,0,0,1-.13.05.27.27,0,0,1-.24-.14.25.25,0,0,1,.1-.37l1.53-.94a.3.3,0,0,1,.38.11.28.28,0,0,1,0,.2V336a.26.26,0,0,1-.27.27.27.27,0,0,1-.27-.27Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.17,335.74l3.72-3.35a2,2,0,0,0-2.75-3l-.39.35a.26.26,0,0,1-.38,0,.26.26,0,0,1,0-.39l.39-.36a2.6,2.6,0,0,1,1.76-.67,2.61,2.61,0,0,1,2.59,2.59,2.64,2.64,0,0,1-.85,1.93l-3.19,2.88h3.77a.28.28,0,0,1,0,.55h-4.48a.26.26,0,0,1-.21-.08A.31.31,0,0,1,312.17,335.74Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.88,335.74l3.72-3.35a2,2,0,0,0-2.75-3l-.39.35a.26.26,0,0,1-.38,0,.26.26,0,0,1,0-.39l.39-.36a2.62,2.62,0,0,1,1.76-.67,2.61,2.61,0,0,1,2.59,2.59,2.64,2.64,0,0,1-.85,1.93l-3.19,2.88h3.77a.28.28,0,0,1,0,.55h-4.48a.26.26,0,0,1-.21-.08A.31.31,0,0,1,318.88,335.74Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.17,335.74l3.72-3.35a2.07,2.07,0,0,0,.68-1.52,2.05,2.05,0,0,0-3.43-1.51l-.39.35a.28.28,0,1,1-.38-.4l.39-.36a2.64,2.64,0,0,1,1.76-.67,2.61,2.61,0,0,1,2.59,2.59,2.61,2.61,0,0,1-.85,1.93l-3.18,2.88h3.76a.28.28,0,0,1,0,.55h-4.48a.23.23,0,0,1-.2-.08A.31.31,0,0,1,349.17,335.74Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.7,328.78l-2.06,2.11a2.69,2.69,0,0,1,1.35,4.55,2.7,2.7,0,0,1-1.91.79,2.64,2.64,0,0,1-1.89-.79.27.27,0,0,1,0-.4.27.27,0,0,1,.39,0,2.14,2.14,0,0,0,1.5.61,2.16,2.16,0,0,0,1.52-.61,2.13,2.13,0,0,0,.62-1.51,2.07,2.07,0,0,0-.62-1.5,2.1,2.1,0,0,0-1.5-.63.3.3,0,0,1-.23-.11h0a.28.28,0,0,1,0-.41l2-2h-3a.28.28,0,1,1,0-.56h3.72a.28.28,0,0,1,.28.28.24.24,0,0,1,0,.12Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.91,335.74l3.72-3.35a2.07,2.07,0,0,0,.68-1.52,2.05,2.05,0,0,0-3.43-1.51l-.39.35a.28.28,0,1,1-.38-.4l.39-.36a2.64,2.64,0,0,1,1.76-.67,2.61,2.61,0,0,1,2.59,2.59,2.61,2.61,0,0,1-.85,1.93l-3.18,2.88h3.76a.28.28,0,0,1,0,.55H386.1a.23.23,0,0,1-.2-.08A.31.31,0,0,1,385.91,335.74Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.85,334.6h-4.34a.25.25,0,0,1-.17-.06.26.26,0,0,1,0-.39l4.6-5.73h0a.26.26,0,0,1,.38,0,.28.28,0,0,1,.09.13.2.2,0,0,0,0,.05v5.49h.54a.28.28,0,1,1,0,.55h-.54V336a.28.28,0,0,1-.55,0Zm0-.55v-4.66l-3.77,4.66Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.18,335.74l3.72-3.35a2,2,0,0,0-2.75-3l-.39.35a.26.26,0,0,1-.38,0,.26.26,0,0,1,0-.39l.38-.36a2.64,2.64,0,0,1,1.77-.67,2.61,2.61,0,0,1,2.59,2.59,2.62,2.62,0,0,1-.86,1.93l-3.18,2.88h3.76a.28.28,0,1,1,0,.55h-4.47a.26.26,0,0,1-.21-.08A.31.31,0,0,1,422.18,335.74Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.08,335.45a.27.27,0,0,1,0-.4.28.28,0,0,1,.4,0,2.14,2.14,0,0,0,1.5.61,2.13,2.13,0,1,0-1.5-3.62.27.27,0,0,1-.39,0A.15.15,0,0,1,429,332h0a.08.08,0,0,1,0,0,.25.25,0,0,1,0-.09.35.35,0,0,0,0-.06l.38-3.2a.26.26,0,0,1,.12-.21.26.26,0,0,1,.18-.06h3.71a.28.28,0,0,1,.28.28.27.27,0,0,1-.28.28h-3.47l-.29,2.37a2.7,2.7,0,0,1,1.36-.37,2.7,2.7,0,0,1,2.68,2.7,2.65,2.65,0,0,1-.79,1.91,2.75,2.75,0,0,1-1.91.78A2.68,2.68,0,0,1,429.08,335.45Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,365.29l3.72-3.35a2.09,2.09,0,0,0,.68-1.53,2,2,0,0,0-.53-1.36,2.05,2.05,0,0,0-1.51-.67,2.09,2.09,0,0,0-1.39.52l-.39.35a.27.27,0,0,1-.37-.39l.38-.37a2.69,2.69,0,0,1,1.77-.67,2.54,2.54,0,0,1,1.91.85,2.57,2.57,0,0,1,.68,1.74,2.64,2.64,0,0,1-.86,1.94l-3.18,2.87h3.76a.28.28,0,0,1,0,.56H203.4a.28.28,0,0,1-.2-.49Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.8,359.56a3.24,3.24,0,0,1,2.78-1.73.28.28,0,0,1,.29.26.3.3,0,0,1-.27.3,2.68,2.68,0,0,0-2.32,1.44,5,5,0,0,0-.57,1.59,2.62,2.62,0,1,1-.66,1.82,4.43,4.43,0,0,1,0-.52A6.48,6.48,0,0,1,210.8,359.56Zm-.19,3.64a.77.77,0,0,0,0,.15.22.22,0,0,1,0,.08,2.13,2.13,0,1,0,0-.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,365.29l3.72-3.35a2.09,2.09,0,0,0,.68-1.53,2,2,0,0,0-.54-1.36,2,2,0,0,0-1.51-.67,2,2,0,0,0-1.38.52l-.39.35a.26.26,0,0,1-.39,0,.26.26,0,0,1,0-.38l.39-.37a2.69,2.69,0,0,1,1.76-.67,2.61,2.61,0,0,1,2.59,2.59,2.63,2.63,0,0,1-.85,1.94l-3.18,2.87h3.76a.28.28,0,0,1,0,.56h-4.48a.26.26,0,0,1-.2-.08A.31.31,0,0,1,240,365.29Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.82,365.39l3-7h-3.85a.27.27,0,0,1,0-.54h4.21a.33.33,0,0,1,.17,0,.28.28,0,0,1,.15.17.24.24,0,0,1,0,.09.26.26,0,0,1,0,.15l-3.08,7.32a.3.3,0,0,1-.25.17.18.18,0,0,1-.12,0A.31.31,0,0,1,247.82,365.39Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.14,365.29l3.72-3.35a2.09,2.09,0,0,0,.68-1.53,2,2,0,0,0-.53-1.36,2.05,2.05,0,0,0-1.51-.67,2.09,2.09,0,0,0-1.39.52l-.39.35a.27.27,0,1,1-.37-.39l.38-.37a2.69,2.69,0,0,1,1.77-.67,2.54,2.54,0,0,1,1.91.85,2.57,2.57,0,0,1,.68,1.74,2.66,2.66,0,0,1-.85,1.94l-3.19,2.87h3.77a.28.28,0,0,1,0,.56h-4.48a.28.28,0,0,1-.2-.49Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.45,357.82a1.65,1.65,0,0,1,1,3,2.58,2.58,0,1,1-2,0,1.67,1.67,0,0,1-.66-1.34A1.64,1.64,0,0,1,285.45,357.82Zm0,7.41a2,2,0,1,0-2-2A2,2,0,0,0,285.45,365.23Zm0-4.64a1.13,1.13,0,0,0,1.11-1.12,1.11,1.11,0,0,0-2.22,0A1.12,1.12,0,0,0,285.45,360.59Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.93,365.29l3.72-3.35a2.05,2.05,0,0,0,.68-1.53,2,2,0,0,0-.53-1.36,2.05,2.05,0,0,0-1.51-.67,2.09,2.09,0,0,0-1.39.52l-.39.35a.25.25,0,0,1-.38,0,.25.25,0,0,1,0-.38l.39-.37a2.67,2.67,0,0,1,1.76-.67,2.53,2.53,0,0,1,1.91.85,2.57,2.57,0,0,1,.68,1.74,2.63,2.63,0,0,1-.85,1.94l-3.19,2.87h3.77a.28.28,0,0,1,0,.56h-4.48a.28.28,0,0,1-.2-.49Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.41,357.82a2.61,2.61,0,0,1,2.61,2.32.33.33,0,0,0,0,.06c0,.21,0,.44,0,.68a6.62,6.62,0,0,1-.76,3.17,3.32,3.32,0,0,1-2.79,1.73h0a.27.27,0,0,1-.28-.26.29.29,0,0,1,.27-.3,2.69,2.69,0,0,0,2.32-1.44,5.39,5.39,0,0,0,.57-1.59,2.63,2.63,0,1,1-2-4.37Zm2.08,2.62a2.08,2.08,0,1,0-2.08,2.06A2.06,2.06,0,0,0,323.49,360.44Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.55,358.32l-2.06,2.12a2.66,2.66,0,0,1,1.36.72,2.69,2.69,0,0,1,.79,1.91,2.62,2.62,0,0,1-.8,1.91,2.71,2.71,0,0,1-1.91.8,2.65,2.65,0,0,1-1.9-.8.28.28,0,0,1,.4-.4,2.14,2.14,0,0,0,3,0,2.12,2.12,0,0,0,.63-1.51,2.1,2.1,0,0,0-.63-1.5,2.07,2.07,0,0,0-1.5-.62.27.27,0,0,1-.22-.12h0a.3.3,0,0,1,0-.41l2-2h-3a.29.29,0,1,1,0-.57h3.71a.29.29,0,0,1,.29.28.18.18,0,0,1,0,.13A.26.26,0,0,1,353.55,358.32Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.79,361.8a5.07,5.07,0,0,1,.76-2.79,2.26,2.26,0,0,1,4,0,5.16,5.16,0,0,1,.77,2.79,5,5,0,0,1-.77,2.77,2.24,2.24,0,0,1-4,0A5,5,0,0,1,355.79,361.8Zm.56,0a4.53,4.53,0,0,0,.67,2.47,1.69,1.69,0,0,0,3,0,4.77,4.77,0,0,0,0-4.94,1.69,1.69,0,0,0-3,0A4.53,4.53,0,0,0,356.35,361.8Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4,299.23l-1.13.66a.28.28,0,0,1-.13,0,.27.27,0,0,1-.24-.14.26.26,0,0,1,.1-.37l1.54-.93a.28.28,0,0,1,.37.1.29.29,0,0,1,0,.2v7.31a.27.27,0,0,1-.27.28.28.28,0,0,1-.27-.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.9,305.89l3.72-3.36a2.05,2.05,0,0,0,.68-1.52,2,2,0,0,0-2.05-2,2.07,2.07,0,0,0-1.38.52l-.39.35a.27.27,0,0,1-.39,0,.26.26,0,0,1,0-.39l.38-.36a2.69,2.69,0,0,1,1.76-.67,2.62,2.62,0,0,1,2.6,2.59,2.6,2.6,0,0,1-.86,1.93l-3.18,2.88h3.76a.28.28,0,0,1,.28.28.29.29,0,0,1-.28.28h-4.48a.3.3,0,0,1-.2-.08A.31.31,0,0,1,208.9,305.89Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.76,299.23l-1.13.66a.27.27,0,0,1-.38-.1.27.27,0,0,1,.11-.37l1.53-.93a.29.29,0,0,1,.38.1.36.36,0,0,1,0,.2v7.31a.27.27,0,0,1-.27.28.28.28,0,0,1-.27-.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08,298.92,248,301a2.69,2.69,0,0,1,2.15,2.64,2.64,2.64,0,0,1-.8,1.91,2.71,2.71,0,0,1-1.91.8,2.61,2.61,0,0,1-1.89-.8.27.27,0,0,1,0-.4.27.27,0,0,1,.39,0,2.15,2.15,0,0,0,1.5.62,2.19,2.19,0,0,0,1.52-.62,2.11,2.11,0,0,0,.62-1.51,2.13,2.13,0,0,0-2.13-2.13.27.27,0,0,1-.22-.11h0a.28.28,0,0,1,0-.41l2-2h-3a.29.29,0,0,1-.29-.29.28.28,0,0,1,.29-.28h3.71a.28.28,0,0,1,.29.28.2.2,0,0,1,0,.13A.26.26,0,0,1,250.08,298.92Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.59,299.23l-1.13.66a.28.28,0,0,1-.13,0,.27.27,0,0,1-.24-.14.26.26,0,0,1,.1-.37l1.53-.93a.29.29,0,0,1,.38.1.36.36,0,0,1,0,.2v7.31a.27.27,0,0,1-.27.28.28.28,0,0,1-.27-.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.66,304.74h-4.34a.21.21,0,0,1-.17-.06.25.25,0,0,1,0-.38l4.61-5.73h0a.25.25,0,0,1,.38,0,.45.45,0,0,1,.1.14s0,0,0,0v5.49h.53a.28.28,0,1,1,0,.55h-.53v1.36a.29.29,0,0,1-.29.28.28.28,0,0,1-.27-.28Zm0-.55v-4.66l-3.76,4.66Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.08,299.23l-1.12.66a.33.33,0,0,1-.14,0,.29.29,0,0,1-.24-.14.26.26,0,0,1,.11-.37l1.53-.93a.27.27,0,0,1,.37.1.3.3,0,0,1,0,.2v7.31a.27.27,0,0,1-.27.28.29.29,0,0,1-.28-.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.77,305.59a.27.27,0,0,1,0-.4.3.3,0,0,1,.41,0,2.11,2.11,0,0,0,3,0,2.09,2.09,0,0,0,.62-1.5,2.08,2.08,0,0,0-2.11-2.12,2.09,2.09,0,0,0-1.51.62.27.27,0,0,1-.4,0,.16.16,0,0,1-.07-.09h0a0,0,0,0,1,0,0,.31.31,0,0,1,0-.1.43.43,0,0,0,0-.05l.39-3.21a.22.22,0,0,1,.11-.2.24.24,0,0,1,.18-.07h3.71a.29.29,0,0,1,0,.57h-3.47l-.28,2.36a2.7,2.7,0,0,1,3.25,4.24,2.79,2.79,0,0,1-1.91.79A2.65,2.65,0,0,1,317.77,305.59Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.75,299.23l-1.12.66a.27.27,0,0,1-.38-.1.26.26,0,0,1,.11-.37l1.53-.93a.29.29,0,0,1,.38.1.36.36,0,0,1,0,.2v7.31a.27.27,0,0,1-.27.28.29.29,0,0,1-.28-.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.14,300.16a3.24,3.24,0,0,1,2.79-1.73.27.27,0,0,1,.28.26.3.3,0,0,1-.27.3,2.69,2.69,0,0,0-2.32,1.44,5.47,5.47,0,0,0-.57,1.59,2.63,2.63,0,0,1,4.61,1.73,2.64,2.64,0,0,1-5.27.09,4.43,4.43,0,0,1,0-.52A6.59,6.59,0,0,1,355.14,300.16ZM355,303.8a.59.59,0,0,0,0,.14.17.17,0,0,1,0,.08,2.13,2.13,0,1,0,0-.27Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.08,299.23l-1.13.66a.27.27,0,0,1-.38-.1.26.26,0,0,1,.11-.37l1.53-.93a.29.29,0,0,1,.38.1.36.36,0,0,1,0,.2v7.31a.27.27,0,0,1-.27.28.28.28,0,0,1-.27-.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.86,306l2.95-7H392a.28.28,0,0,1-.27-.27.28.28,0,0,1,.27-.28h4.21a.25.25,0,0,1,.17,0,.31.31,0,0,1,.15.17.24.24,0,0,1,0,.09.23.23,0,0,1-.05.15l-3.08,7.32a.27.27,0,0,1-.25.17.17.17,0,0,1-.11,0A.29.29,0,0,1,392.86,306Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.82,299.23l-1.12.66a.37.37,0,0,1-.14,0,.29.29,0,0,1-.24-.14.26.26,0,0,1,.1-.37l1.54-.93a.28.28,0,0,1,.37.1.3.3,0,0,1,0,.2v7.31a.28.28,0,0,1-.28.28.28.28,0,0,1-.27-.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.91,298.42a1.65,1.65,0,0,1,1,3,2.58,2.58,0,1,1-2,0,1.69,1.69,0,0,1-.66-1.34A1.64,1.64,0,0,1,429.91,298.42Zm0,7.41a2,2,0,1,0-2-2A2,2,0,0,0,429.91,305.83Zm0-4.64a1.13,1.13,0,0,0,1.12-1.12,1.11,1.11,0,0,0-2.22,0A1.12,1.12,0,0,0,429.91,301.19Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.39,
    y: 144.85,
    width: 161.38,
    height: 2.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.38 150.15 150.38 142.44 145.75 146.29 150.38 150.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.77 142.44 387.77 150.15 392.4 146.29 387.77 142.44",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.36,
    y: 58.19,
    width: 426.02,
    height: 69.17,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.79,
    y: 127.36,
    width: 120.58,
    height: 223.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.23,135.45a11,11,0,0,1,11-10.8,11.22,11.22,0,0,1,6.93,2.34,1.72,1.72,0,0,1-2.1,2.73,7.48,7.48,0,0,0-4.83-1.65,7.94,7.94,0,0,0-5.4,2.16,7.4,7.4,0,0,0-2.19,5.22,7.29,7.29,0,0,0,2.19,5.22,7.94,7.94,0,0,0,5.4,2.16,7.54,7.54,0,0,0,4.83-1.65,1.82,1.82,0,0,1,2.4.33,1.77,1.77,0,0,1-.3,2.4,11.22,11.22,0,0,1-6.93,2.34A11,11,0,0,1,280.23,135.45Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,141.3h-7.29l-1.47,3.9a1.68,1.68,0,0,1-1.56,1.05,1.75,1.75,0,0,1-.57-.09,1.7,1.7,0,0,1-1-2.16l6.63-17.66a1.67,1.67,0,0,1,1.59-1.06,1.65,1.65,0,0,1,1.59,1.06L324.51,144a1.7,1.7,0,0,1-1,2.16,1.68,1.68,0,0,1-2.1-1Zm-1.23-3.3-2.43-6.45L313.86,138Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,144.6V126.9a1.65,1.65,0,0,1,1.65-1.65,1.67,1.67,0,0,1,1.68,1.65v16h8.13a1.67,1.67,0,0,1,0,3.33h-9.81A1.65,1.65,0,0,1,334,144.6Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.31,144.6V126.9a1.63,1.63,0,0,1,1.65-1.65h9.81a1.66,1.66,0,0,1,1.65,1.65,1.69,1.69,0,0,1-1.65,1.68h-8.13v5.49h7a1.67,1.67,0,0,1,0,3.33h-7v5.52h8.13a1.67,1.67,0,0,1,0,3.33h-9.72c-.06,0-.06,0-.06,0l0,0A1.65,1.65,0,0,1,356.31,144.6Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.8,144.6a1.64,1.64,0,1,1-3.27,0V127.14a1.62,1.62,0,0,1,.66-1.38,1.65,1.65,0,0,1,2.28.36l9.69,13.41V127.17a1.63,1.63,0,0,1,1.62-1.62,1.66,1.66,0,0,1,1.65,1.62V144.6a1.66,1.66,0,0,1-1.65,1.65,1.63,1.63,0,0,1-1.23-.6.8.8,0,0,1-.15-.18l-9.6-13.32Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.53,144.6V126.9a1.63,1.63,0,0,1,1.65-1.65h3.54a10.5,10.5,0,0,1,0,21h-3.54A1.65,1.65,0,0,1,406.53,144.6Zm3.33-1.68h1.86a7.17,7.17,0,0,0,0-14.34h-1.86Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.26,141.3H435l-1.47,3.9a1.68,1.68,0,0,1-1.56,1.05,1.75,1.75,0,0,1-.57-.09,1.7,1.7,0,0,1-1-2.16L437,126.34a1.67,1.67,0,0,1,1.59-1.06,1.65,1.65,0,0,1,1.59,1.06L446.82,144a1.7,1.7,0,0,1-1,2.16,1.68,1.68,0,0,1-2.1-1ZM441,138l-2.43-6.45L436.17,138Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.22,143.76a1.66,1.66,0,0,1-1.05,2.1,2.64,2.64,0,0,1-.66.09h0a2.18,2.18,0,0,1-1.17-.33,3,3,0,0,1-1-1.05,8.06,8.06,0,0,1-.63-3.6,2.53,2.53,0,0,0-.36-1.29,2.78,2.78,0,0,0-.9-.87,5.71,5.71,0,0,0-1.68-.72h-3.54v6.51a1.67,1.67,0,0,1-1.68,1.65,1.65,1.65,0,0,1-1.65-1.65V126.9a1.63,1.63,0,0,1,1.65-1.65h5.37A6.42,6.42,0,0,1,467,136.62a4.65,4.65,0,0,1,1.05,1.11,5.68,5.68,0,0,1,1,3.24,7.57,7.57,0,0,0,.12,1.77A1.62,1.62,0,0,1,470.22,143.76ZM466,131.7a3.09,3.09,0,0,0-3.09-3.12h-3.69v6.18h3.69A3.08,3.08,0,0,0,466,131.7Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.69,
    y: 144.22,
    width: 20.77,
    height: 46.82,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.89,
    y: 144.22,
    width: 69.59,
    height: 46.82,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.8,189.11l-1.13.65a.22.22,0,0,1-.14.05.26.26,0,0,1-.23-.14.26.26,0,0,1,.1-.37l1.53-.93a.29.29,0,0,1,.38.1.35.35,0,0,1,0,.2V196a.27.27,0,0,1-.27.28.28.28,0,0,1-.27-.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.42,192.28a5.08,5.08,0,0,1,.77-2.79,2.25,2.25,0,0,1,4,0,5.17,5.17,0,0,1,.78,2.79,5.07,5.07,0,0,1-.78,2.77,2.23,2.23,0,0,1-4,0A5,5,0,0,1,491.42,192.28Zm.56,0a4.49,4.49,0,0,0,.67,2.46,1.69,1.69,0,0,0,3.05,0,4.81,4.81,0,0,0,0-4.93,1.7,1.7,0,0,0-3.05,0A4.5,4.5,0,0,0,492,192.28Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 148.29,
    width: 52.76,
    height: 2.55,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 155.69,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 158.91,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 162.12,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 168.55,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 171.76,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 174.98,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 178.19,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 181.41,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.69,
    y: 197.52,
    width: 20.77,
    height: 66.25,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.89,
    y: 197.52,
    width: 69.59,
    height: 66.25,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487,249.8l3.71-3.35a2.05,2.05,0,0,0,.68-1.53,2,2,0,0,0-.53-1.36,2,2,0,0,0-1.51-.67,2.09,2.09,0,0,0-1.39.52l-.38.35a.26.26,0,0,1-.39,0,.26.26,0,0,1,0-.38l.39-.37a2.67,2.67,0,0,1,1.76-.67,2.53,2.53,0,0,1,1.91.85,2.59,2.59,0,0,1-.17,3.67l-3.19,2.88h3.77a.28.28,0,0,1,0,.56h-4.48a.3.3,0,0,1-.21-.08A.3.3,0,0,1,487,249.8Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.7,249.8l3.71-3.35a2.06,2.06,0,0,0,.69-1.53,2.06,2.06,0,0,0-2.05-2,2.09,2.09,0,0,0-1.39.52l-.38.35a.26.26,0,0,1-.39,0,.26.26,0,0,1,0-.38l.39-.37a2.67,2.67,0,0,1,1.76-.67,2.53,2.53,0,0,1,1.91.85,2.59,2.59,0,0,1-.17,3.67l-3.18,2.88h3.76a.28.28,0,0,1,0,.56h-4.48a.3.3,0,0,1-.21-.08A.3.3,0,0,1,493.7,249.8Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 201.77,
    width: 52.76,
    height: 2.55,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 209.17,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 212.38,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 215.6,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 243.65,
    width: 52.76,
    height: 2.55,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 251.05,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 254.27,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 222.03,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 225.24,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 228.45,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 231.67,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.13,
    y: 234.88,
    width: 43.33,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.55,455.72c2.74,1,82.28,2.5,85.4.72.34-.2.24-3.71,1.41-12.79.06-.44,1.88-2.12,4.71-4.5,10.64-8.91,35.64-27.71,35.64-27.71L414,377l-38.47,37.81-10,9.83s-32.5,17.55-35.72,19.87S323.81,454.67,326.55,455.72Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.55,455.72c2.74,1.06,82.29,2.5,85.4.72.33-.2.24-3.71,1.42-12.79.05-.43,1.87-2.12,4.7-4.5,3.7-3.1,5.46-4.51,11-8.8l-50.47-18.56-3,3-10,9.83s-32.5,17.54-35.71,19.87S323.81,454.67,326.55,455.72Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.07,456.82c2.76,1,87.52,1.89,90.57,0,.71-.44,1.37-5.37,1.9-12.11.06-.85,8.65-7.71,9.82-9l-51.93-17.49-6.56,6.17s-38.22,17.78-41.35,20.2S318.3,455.86,321.07,456.82Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.24,453.65c13.32-.17,72.38.4,85.56,1.24.11,0,.11.08,0,.08-13.2.46-72.26-.54-85.56-1.1C322,453.86,322,453.66,322.24,453.65Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.63,425c5.25-.92,11.65,0,15.61,3.74.15.15-.06.36-.23.31a73.91,73.91,0,0,0-15.37-3.39A.33.33,0,0,1,360.63,425Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.82,427.21c5.25-.91,11.65,0,15.61,3.75.15.14-.06.36-.23.3a73.31,73.31,0,0,0-15.36-3.38A.34.34,0,0,1,356.82,427.21Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,429.45c5.24-.92,11.64,0,15.6,3.74.16.15-.06.36-.22.31A74.05,74.05,0,0,0,353,430.11.33.33,0,0,1,353,429.45Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.21,431.68c5.25-.91,11.64,0,15.6,3.75.16.14-.05.36-.22.3a73.4,73.4,0,0,0-15.37-3.38A.34.34,0,0,1,349.21,431.68Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.36,420.24c3.67,2.93,8.48,4.16,12.78,5.81a.65.65,0,0,0,.83-.64c.09,0,.16-.08.13-.19a28,28,0,0,0-7.93-12.1c-2.16-1.86-6-3.18-8.07-.37S351.21,418.53,353.36,420.24ZM352.07,416c-.85-5.76,5.28-2.67,6.82-1.23a30.43,30.43,0,0,1,2.75,3c1.78,2.2,3.23,4.61,4.78,7-2.07-.94-4.19-1.7-6.29-2.56C357.63,421.18,352.55,419.18,352.07,416Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.68,417.44c-1.23-3.28-5.26-3.07-7.86-1.88a27.84,27.84,0,0,0-11,9.41.14.14,0,0,0,.06.22.66.66,0,0,0,.62.85c4.6-.39,9.56-.24,13.9-2C383,423,385.84,420.54,384.68,417.44ZM373.38,424c-2.26.25-4.51.38-6.76.71,2.15-1.83,4.2-3.74,6.53-5.36a29.6,29.6,0,0,1,3.48-2.15c1.88-1,8.63-2.22,6.21,3.08C381.5,423.22,376.07,423.72,373.38,424Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,412.65l49.07,25.43s51.12-46.27,55.8-46.62S553.32,437.79,588,437.93c35.86.15,37.67-37.42,37.67-37.42l-52.31-12c-37.71-18.59-77-52-102.68-48.85C442.73,343,375,412.65,375,412.65Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,406.18c8.28,4.09,6,2.81,14.2,7,4,2,24.32,12.28,27.76,14.82.08.05,0,.19-.08.16-4.05-1.36-24.12-12-28.11-14.15-8.16-4.34-5.78-3.18-13.89-7.6A.13.13,0,1,1,387,406.18Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.75,426.36c9.59-8.46,41-36,42.3-37a17.35,17.35,0,0,1,3.28-2.46,3.46,3.46,0,0,1,3,.25c1.46.68,2.88,1.42,4.32,2.12l8.51,4.16c11,5.36,21.92,10.87,33,16.06,10.65,5,18.26,9.68,29.39,13.52a166.82,166.82,0,0,0,34.13,8.14c1.43.17,2.87.32,4.31.46.1,0,.1.17,0,.16a136.87,136.87,0,0,1-33.59-6.25c-11-3.38-18.5-7.78-29-12.6-10.85-5-21.55-10.34-32.24-15.65-5.65-2.81-11.28-5.64-16.94-8.41-1.29-.63-3.12-2-4.58-1.32a8,8,0,0,0-1.7,1.25l-1.88,1.56c-2.43,2-41,35.21-42.22,36.17C432.79,426.57,432.66,426.44,432.75,426.36Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.72,400.51s5.87,33.92-11.09,47.25-141.25,11.73-160.11,5.63-19.44-36.52,1.17-43.57c19.61-6.71,103-10,105.08-10.79.52-.21-7.4-4.95-7.36-5.24l19-5.8Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,399.65c0-.14.25-.09.25,0a16.78,16.78,0,0,0,3.92,10.78c2.89,3.33,7.15,5.2,11,7.15.37.19.09.77-.3.66a34.5,34.5,0,0,1-6.81-2.94,16.46,16.46,0,0,1-5.12-4.26A14.65,14.65,0,0,1,600,399.65Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.14,395.45c.86-1.1,1.8-2.15,2.7-3.21,2.12-2.53,4.25-5.07,6.48-7.51.21-.23.62.1.43.35-1.5,2-3.09,3.86-4.65,5.77-.8,1-1.6,2-2.41,2.93a18.55,18.55,0,0,0-2.25,2.85c-.58,1.09.18,2,1.31,2.14a3.9,3.9,0,0,0,2.71-1,35.18,35.18,0,0,0,4.6-4.92c.9-1,1.79-2,2.7-3s2-2.06,3-3.12c.06-.07.18,0,.12.1-.84,1.16-1.61,2.37-2.46,3.52s-1.7,2.3-2.57,3.44-1.67,2.12-2.55,3.16a10.38,10.38,0,0,1-2.59,2.31c-1.61.95-4.41,1.16-5.27-.93A2.91,2.91,0,0,1,562.14,395.45Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.1,453.5c6.5.13,13,.5,19.48.64s12.88.18,19.32.11q19.41-.18,38.78-1.5c13-.9,27.11-2.2,40.07-4,6.2-.86,12.48-1.57,18.61-2.89a29.4,29.4,0,0,0,14.68-7.5c8.39-8.14,11.65-20.1,13-31.54.18-1.53.33-3.07.46-4.61a.08.08,0,1,1,.15,0c-.75,11.72-2.58,23.94-9.95,33.37a29.36,29.36,0,0,1-12,9.32c-5.8,2.33-12.24,2.87-18.37,3.7-13,1.77-27.13,3.13-40.21,4.14s-26.37,1.66-39.57,1.86-26.42,0-39.61-.64c-1.61-.08-3.21-.18-4.82-.32C457,453.64,457,453.5,457.1,453.5Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498,403.63c4.09-.6,8.16-1.18,12.27-1.61s8.31-.8,12.47-1.16c8.22-.69,16.46-1.32,24.7-1.7,4.69-.22,9.37-.25,14.06-.19.15,0,.13.22,0,.23-8.24.75-16.49,1.27-24.74,1.82s-16.47,1.27-24.69,2.05c-4.66.45-9.33.79-14,1.17C497.76,404.27,497.7,403.68,498,403.63Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.44,393.38a63.19,63.19,0,0,1,9.46,5.06,76,76,0,0,1,8.76,6.13c.08.06,0,.16-.1.12-3.22-1.48-6.3-3.34-9.36-5.12a88.61,88.61,0,0,1-9-5.76C552,393.66,552.16,393.26,552.44,393.38Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.6,336.15C570.41,347,545.74,380.32,538,381.42c-8.08,1.16-37.86-1.39-43.29-7.79-2.66-3.13,1.63-30,5.76-28.48s29.61,7.66,32.87,7.18,29.68-26,39.41-31.56C589.51,311.26,579.94,330.33,576.6,336.15Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507,346l-6.28,33.26s29.82,6.11,38.62,3.54,33.38-37.52,40.54-51.34.91-17.46-12-8.85-33.5,27.92-35.5,28S507,346,507,346Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.05,325.19a8.22,8.22,0,0,0-1.77,2.53,8.87,8.87,0,0,0,4.3-4.3A8.22,8.22,0,0,0,571.05,325.19ZM506.7,375.88a8.3,8.3,0,0,0-3,.53,8.83,8.83,0,0,0,6.08,0A8.37,8.37,0,0,0,506.7,375.88Zm48.74-9.94a8.38,8.38,0,0,0-3.05.53,8.19,8.19,0,0,0,3.05.54h.4l.78-1C556.22,366,555.83,366,555.44,365.94Zm-21.23,8a9,9,0,0,0,0,6.08,8.35,8.35,0,0,0,.54-3A8.14,8.14,0,0,0,534.21,373.91Zm25-32.51a7.9,7.9,0,0,0-.53,3,8.13,8.13,0,0,0,.53,3,8.13,8.13,0,0,0,.53-3A7.9,7.9,0,0,0,559.2,341.4Zm11.85-16.21a8.22,8.22,0,0,0-1.77,2.53,8.87,8.87,0,0,0,4.3-4.3A8.22,8.22,0,0,0,571.05,325.19ZM539,352.6a8.1,8.1,0,0,0-1.77,2.53,8.25,8.25,0,0,0,2.53-1.78,8.1,8.1,0,0,0,1.77-2.53A8.42,8.42,0,0,0,539,352.6Zm-30.11-6.22h0l-.27.25a8.1,8.1,0,0,0-1.77,2.53,8.2,8.2,0,0,0,2.53-1.78c.24-.25.47-.5.69-.77Zm12,16.47a8.1,8.1,0,0,0-2.53-1.77,8.08,8.08,0,0,0,1.78,2.53,8.18,8.18,0,0,0,2.52,1.77A8.22,8.22,0,0,0,520.86,362.85Zm34.58,3.09a8.38,8.38,0,0,0-3.05.53,8.19,8.19,0,0,0,3.05.54h.4l.78-1C556.22,366,555.83,366,555.44,365.94Zm3.76-24.54a7.9,7.9,0,0,0-.53,3,8.13,8.13,0,0,0,.53,3,8.13,8.13,0,0,0,.53-3A7.9,7.9,0,0,0,559.2,341.4Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.39,364.15c.51-2.64,2.46-13.18,2.75-15.84a0,0,0,0,0-.08,0c-.77,2.48-3,12.83-3.51,15.47a144.17,144.17,0,0,0-2.6,15.87c0,.09.14.14.17,0C510.55,374.58,511.39,369.34,512.39,364.15Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.89,331.46c-7.18,13.83-31.75,48.77-40.55,51.35-6.67,1.95-25.37-1.08-34.07-2.67L579.45,318C583.62,318.31,584.29,323,579.89,331.46Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.89,397.42l73.34,4.26c-.09-1.5-11.57-43.57-19.82-59.58-10.58-20.54-15.27-23.67-18.41-24.72-4-1.34-12.26-1.34-14.69,2.54C561.21,340.86,552.89,396.49,553.89,397.42Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.76,324.55c-.39.78-.77,1.58-1.15,2.42a11.74,11.74,0,0,0,1.2-1,8.22,8.22,0,0,0,1.77-2.53A7.15,7.15,0,0,0,571.76,324.55Zm22.08,67.95a8.1,8.1,0,0,0-1.77,2.53,8.22,8.22,0,0,0,2.53-1.77,8.34,8.34,0,0,0,1.77-2.53A8.22,8.22,0,0,0,593.84,392.5Zm-22.08-67.95c-.39.78-.77,1.58-1.15,2.42a11.74,11.74,0,0,0,1.2-1,8.22,8.22,0,0,0,1.77-2.53A7.15,7.15,0,0,0,571.76,324.55Zm43.08,35.83h0a5,5,0,0,0-.57-.28,7.11,7.11,0,0,0,1.1,1.78Zm-16.12-34a11.42,11.42,0,0,0-.9-.8h0a6.93,6.93,0,0,0-1.61-1,8.22,8.22,0,0,0,1.77,2.53,9.14,9.14,0,0,0,1.83,1.42,5.08,5.08,0,0,0,.7.35A8.25,8.25,0,0,0,598.72,326.41ZM578.85,360.7a8.1,8.1,0,0,0-2.53-1.77,8.25,8.25,0,0,0,1.78,2.53,8.1,8.1,0,0,0,2.53,1.77A8.42,8.42,0,0,0,578.85,360.7Zm18.41,10.15a8.14,8.14,0,0,0-3,.54,9,9,0,0,0,6.08,0A8.11,8.11,0,0,0,597.26,370.85Zm-17.89-32.16a8.11,8.11,0,0,0-3,.54,8.3,8.3,0,0,0,3,.53,8.16,8.16,0,0,0,3-.53A8.18,8.18,0,0,0,579.37,338.69Zm-7.94,43.81a8.11,8.11,0,0,0-.54,3,8.38,8.38,0,0,0,.54,3,9,9,0,0,0,0-6.08Zm42-3.05a8.86,8.86,0,0,0,0,6.09,9,9,0,0,0,0-6.09Zm-15-32.8a8.83,8.83,0,0,0,0,6.08,8.37,8.37,0,0,0,.53-3A8.09,8.09,0,0,0,598.35,346.65Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.24,326.72c18.53,22.79,38.78,60.63,28.86,67.95-9.05,6.69-40.37-1.8-59.86-10.65-3.72-1.68,13.44-34.4,17.2-32.19a112.14,112.14,0,0,0,12.3,6.34c1.08.36-4.52-7.28-10.25-25.21C583.67,314.74,590.65,313.7,601.24,326.72Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.18,346.75c-.23,3.9,9.43,3.64,9.43,3.64a7.22,7.22,0,0,0-3.14,3.76c-.88,2.84,3.18,5.46,3.18,5.46A8.83,8.83,0,0,0,546,364.1c-.57,2.8,3.15,6,3.15,6a7.8,7.8,0,0,0,.13,5.43c2,4.56,9.73,5.06,14.42,6.31a101.77,101.77,0,0,1,15.3,5.79l10.69-34.55S569.74,339.8,564,339.77C559.11,339.74,539.53,340.79,539.18,346.75Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.69,350.29c5.17-1.21,10.62-1.18,15.88-1.1.12,0,.12.19,0,.18-5.23-.14-10.63,1.11-15.85,1.17A.13.13,0,0,1,548.69,350.29Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.81,359.22a13.71,13.71,0,0,1,3.62,0c1.28.09,2.56.19,3.84.32,2.55.26,5.1.57,7.64,1,.12,0,.12.19,0,.18-2.55-.25-5.1-.46-7.66-.6l-3.84-.19a16.16,16.16,0,0,1-3.61-.31A.18.18,0,0,1,548.81,359.22Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.23,370.13a10,10,0,0,1,3.26.17l3.49.4c2.33.26,4.66.51,7,.68a.1.1,0,0,1,0,.19c-2.38-.17-4.75-.3-7.12-.49-1.17-.09-2.33-.18-3.49-.29a9,9,0,0,1-3.14-.54A.07.07,0,0,1,549.23,370.13Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.61,352.77,581,390s46.49,14.82,52,3.14-19.84-57.44-35.15-70.93-10.38,6.74-10,8.36c1.78,7.19,10.86,26.17,10.86,26.17Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.35,346.65a8.83,8.83,0,0,0,0,6.08,8.37,8.37,0,0,0,.53-3A8.09,8.09,0,0,0,598.35,346.65Zm15,32.8a8.86,8.86,0,0,0,0,6.09,9,9,0,0,0,0-6.09Zm-16.13-8.6a8.14,8.14,0,0,0-3,.54,9,9,0,0,0,6.08,0A8.11,8.11,0,0,0,597.26,370.85Zm1.46-44.44a8.18,8.18,0,0,0-2.52-1.77,8.87,8.87,0,0,0,4.3,4.3A8.25,8.25,0,0,0,598.72,326.41Zm32.21,63.94a8.18,8.18,0,0,0-2.52-1.77,8.87,8.87,0,0,0,4.3,4.3A8.25,8.25,0,0,0,630.93,390.35Zm-14.14-28.48a8.22,8.22,0,0,0-2.53-1.77,8.87,8.87,0,0,0,4.3,4.3A8.22,8.22,0,0,0,616.79,361.87ZM593.84,392.5c-.27.29-.54.58-.79.89l1.11.27c.15-.13.3-.26.44-.4a8.34,8.34,0,0,0,1.77-2.53A8.22,8.22,0,0,0,593.84,392.5Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.42,352.84c5.31,2.2,19.13,10,22.09,13.1.08.09,0,.23-.12.16-2.95-2.33-20-11.85-22.72-13a4.07,4.07,0,0,1-.21.41c-.1.13-.17,0-.16-.07s.22-.86.25-.91Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.33,374.13c.65-2.6,3.18-13,3.61-15.66,0,0-.06-.07-.07,0-.91,2.43-3.7,12.64-4.36,15.25a145.58,145.58,0,0,0-3.46,15.7c0,.09.13.15.16.05C591.93,384.44,593.05,379.26,594.33,374.13Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.13,357c-1.31-3.29-3-6.44-4.4-9.66s-3-6.41-4.31-9.66c0,0-.09,0-.08,0,.81,2.21,1.61,4.42,2.47,6.6-.27-.35-.54-.72-.79-1.08-.47-.67-.89-1.37-1.31-2.07,0,0-.08,0-.07,0a10.92,10.92,0,0,0,1.2,2.2,15.21,15.21,0,0,0,1.18,1.45c.36.89.73,1.77,1.12,2.66,1.44,3.25,2.52,6.46,4.44,9.47C598.65,357.1,599.17,357.12,599.13,357Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.12,397.07c-9.6,1.35-39.78-5.64-44.92-7,.09-.55.08-.75.22-1.52,0-.1-.14-.16-.17-.05-.19.73-.76,2.17-.56,2.27,2.45,1.11,36.07,8.78,45.43,6.51C626.26,397.27,626.27,397.05,626.12,397.07Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "502.04 342.3 462.76 346.73 449.06 291.98 488.34 287.55 502.04 342.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "500.11 342.52 460.83 346.95 447.13 292.2 486.41 287.77 500.11 342.52",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.76,356.07a4.27,4.27,0,0,0,4.58,3.35,3.46,3.46,0,0,0,3.06-4.21,4.28,4.28,0,0,0-4.59-3.35A3.46,3.46,0,0,0,517.76,356.07Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.85,344c-1.72,4.54-6.52,10.4-6.66,14a4.16,4.16,0,0,0,2.64,4.19s-3.43,2.06-3,5.36c.22,1.7,3.11,2.85,3.11,2.85s-2.67,1.78-2.12,4.69c.43,2.32,3.27,3.13,3.27,3.13s-1.77,2.9-.57,5.12c2.44,4.5,22.63,2.88,25.16-4.81,1.17-3.58-3.74-2.92-3.74-2.92s6.83-2.66,6.61-6.83-6.56-2.92-6.56-2.92,6.6-2.64,5.93-6.94c-.7-4.48-6.82-2.15-6.82-2.15s4.25-3.4,3-6.58c-2.1-5.24-10.06,2.2-14.58,1.51l-3-7.13Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.32,350.68c1.26-4.45-4.52-9.35-3.93-13.78.81-6,7.89-.75,10.05,7.68l.53,6.84Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.5,378.42a.06.06,0,0,0,0,.11,35.18,35.18,0,0,0,20.7-2.91c.21-.1.13-.47-.12-.4A72,72,0,0,1,494.5,378.42Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.83,370.46c-.08,0-.08.13,0,.15,7,1.08,15.72-.16,22.39-4.58.23-.15.29-.52,0-.36C510.57,368.27,499.38,370.5,492.83,370.46Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.47,356.31c-6.57,4-13.76,5.48-21.36,5.94-.09,0-.08.15,0,.17,3.78.78,8.59,0,12.28-1a20.26,20.26,0,0,0,9.2-4.92C514.71,356.44,514.61,356.22,514.47,356.31Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.45,332.08c4.29.16,10.09-7.49,11.87-13.11.11-.39-1.14-4-2.46-8.35-.8-2.68-1.61-5.67-2.16-8.46-.11-.57-16.65,7.7-16.65,7.7a45.27,45.27,0,0,1,3.8,10.37,5.87,5.87,0,0,1,.1,1.16c0,.06,0,.12,0,.2C573,323.83,574.3,331.92,578.45,332.08Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.64,302.44c.11,4.88-.57,16.84-9.86,18.89a10.52,10.52,0,0,1-1.81.26.7.7,0,0,1,0-.2,8.09,8.09,0,0,0-.11-1.16,45.22,45.22,0,0,0-3.8-10.38S581,303.89,584.64,302.44Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.08,279.91c3.71,5.47,5.93,23.89,2.84,29.11-4.47,7.57-14.5,11.26-21.6,5.27-6.89-5.82-9.36-29.88-5.66-34.9C563.11,272,576.6,271.84,582.08,279.91Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.31,295.86c0-.05.1.05.11.1.07,1.25.35,2.67,1.52,3,0,0,0,.07,0,.07C568.54,298.94,568.18,297.05,568.31,295.86Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.31,294.46c2-.33,2.5,3.68.65,4S567.64,294.73,569.31,294.46Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.38,296.77s-.09.07-.09.12c.2,1.24.22,2.69-.85,3.24,0,0,0,.08,0,.07C561.8,299.83,561.76,297.91,561.38,296.77Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.1,295.62c-2,.1-1.66,4.12.21,4S561.79,295.53,560.1,295.62Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.43,291.76a15,15,0,0,1-1.62-.34,2.7,2.7,0,0,1-1.59-.66.89.89,0,0,1,0-1.05,2.12,2.12,0,0,1,2.09-.49,3.11,3.11,0,0,1,2,1.1A.91.91,0,0,1,570.43,291.76Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558,293.85a15.15,15.15,0,0,0,1.58-.49,2.73,2.73,0,0,0,1.52-.81.86.86,0,0,0-.1-1,2.11,2.11,0,0,0-2.13-.29A3.09,3.09,0,0,0,557,292.5.91.91,0,0,0,558,293.85Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.2,306.64c-.14.39-.22.89-.6,1.13a3.4,3.4,0,0,1-1.34.34,0,0,0,0,0,0,.08,1.67,1.67,0,0,0,1.72-.13,1.33,1.33,0,0,0,.37-1.43C572.31,306.56,572.22,306.58,572.2,306.64Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.07,303.57a4.32,4.32,0,0,1-2.58,2.24,5.5,5.5,0,0,1-1.51.26h-.58a.31.31,0,0,1-.28-.24h0a.57.57,0,0,1,0-.13h0v-.11c-.14-.95-.23-2.41-.23-2.41-.33.21-2,1.24-2,.74a63.37,63.37,0,0,1,0-13,.12.12,0,0,1,.23,0c.42,4,.14,8,.5,12a7.64,7.64,0,0,1,1.92-.86c.14,0,.12,2.84.22,3.26l0,0a5.89,5.89,0,0,0,4.2-1.91C570,303.39,570.13,303.46,570.07,303.57Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567,305.84a4.65,4.65,0,0,0,2.21.91,2.2,2.2,0,0,0,1.26-.26c.83-.48.63-1.31.27-2a5.17,5.17,0,0,0-.7-1A6,6,0,0,1,567,305.84Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.19,306.75a2.2,2.2,0,0,0,1.26-.26c.83-.48.63-1.31.27-2A2.16,2.16,0,0,0,569.19,306.75Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.26,293.19c-4.5,1.75-8.6-3-8.9-7.75,0,0-11.73,5.42-15.37-4.23a10.1,10.1,0,0,1-6.59,6.88l-.24,4.05c-1.37,0-3.81-3.13-1.61-6.88,0,0-1.3-5,1.4-9a7,7,0,0,1,6.88-3.24,10.6,10.6,0,0,1,6.82-4.11,9,9,0,0,1,7.82,2.72s6.42-.72,8.79,3.26a9.36,9.36,0,0,1,1,7.57s2,1.22,2.41,5.13C589.94,290.09,588.61,292.66,587.26,293.19Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563,280.26a11.91,11.91,0,0,0,.71,2.41,10,10,0,0,0,1.17,2.18,6.47,6.47,0,0,0,3.92,2.65,10.61,10.61,0,0,0,4.87-.27c.78-.27,1.59-.48,2.37-.8s1.54-.67,2.32-1c-.72.43-1.47.84-2.2,1.26s-1.58.64-2.37,1a10.43,10.43,0,0,1-5.12.41,6.81,6.81,0,0,1-4.17-3A10.17,10.17,0,0,1,563,280.26Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.45,287.89a13.57,13.57,0,0,0,3.09-3.15,8,8,0,0,0,1-1.94,9.61,9.61,0,0,0,.45-2.17,5.36,5.36,0,0,1,0,2.29,6,6,0,0,1-.92,2.15,7.31,7.31,0,0,1-1.58,1.7A6.93,6.93,0,0,1,558.45,287.89Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.76,295.28s2.33-6.81,5.31-6.14,2.37,9.75-.33,11.75a3.2,3.2,0,0,1-4.59-.47Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.83,291.74a0,0,0,0,1,0,.07c-1.87,1.47-2.42,3.76-2.61,6a1.75,1.75,0,0,1,2.4-1.19c.07,0,0,.12,0,.12a2,2,0,0,0-1.89,1.26,9.7,9.7,0,0,0-.52,2c0,.22-.41.22-.4,0v-.05C584,297.23,585,292.84,587.83,291.74Z",
    transform: "translate(-49.57 -40.56)",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsHeroCropped);
export default __webpack_public_path__ + "static/media/events_hero-cropped.7912dff4cf005bd26f028d168b84e42f.svg";
export { ForwardRef as ReactComponent };